const preloader = (() => {
    function init() {
        window.addEventListener('load', () => {
            setTimeout(() => {
                document.querySelector('body').classList.add("loaded")
            }, 300);
        });
    }

    return {
        init,
    };
})();

export default preloader;